import templateUrl from './trip-planner-form.html';
import clone from 'lodash/clone';
import head from 'lodash/head';

export const tripPlannerFormComponent = {
	bindings: {
		type: '@',
		onCancel: '&',
		onClose: '&',
		serviceTypeList: '<',
		defaultServiceType: '<',
		selectedTime: '<',
		selectedDate: '<',
		onTimeChange: '&',
		onApply: '&',
		advanceOptionsDetails: '<',
		directionDetails: '<',
		hideShowLoader: '&',
		onCloseTripPlanningForm: '&'
	},

	templateUrl,

	controller: class TripPlannerFormComponent {
		constructor($state, $timeout, TripPlannerService, GoogleLocationService, GoogleAnalytics) {
			'ngInject';

			this.$state = $state;
			this.$timeout = $timeout;
			this.tripPlannerService = TripPlannerService;
			this.googleLocationService = GoogleLocationService;
			this.googleAnalytics = GoogleAnalytics;
		}

		$onInit() {
			this.directionDetails = this.directionDetails || {
				origin: {},
				destination: {}
			};
			this.googleLocationType = 'direction';
			this.originCoverageError = '';
			this.destinationCoverageError = '';
			this.isValidOrigin = false;
			this.isValidDestination = false;
			this.isAdvanceOptionsEnabled = false;
			this.isOriginAnDestinationSame = false;
			this.isMobileView = this.type === 'mobileSearch' ? true : false;
			this.selectedServiceType = this.defaultServiceType;
			this.advanceOptionsDetails = clone(this.advanceOptionsDetails) || {
				requirements: "",
				age: "",
				isVeteran: null,
				isMedicaid: null
			};

			this.payerList = [{
				id: 1,
				name: "Madicaid"
			}]

			this.medicalMemberOptions = [{
				id: "true",
				title: "yes"
			}, {
				id: "false",
				title: "no"
			}];

			this.veteranOptions = [{
				id: "true",
				title: "yes"
			}, {
				id: "false",
				title: "no"
			}];

			this.specialRequirementsOptions = [{
				id: 'wheelchair_access',
				name: "Wheelchair Access"
			}, {
				id: 'door_to_door',
				name: "Door To Door"
			}, {
				id: 'door_through_door',
				name: "Door Through Door"
			}, {
				id: 'curb_to_curb',
				name: "Curb To Curb"
			}];

			this.ageRangeOptions = [{
				id: '1',
				name: "1-17"
			}, {
				id: '2',
				name: "18-49"
			}, {
				id: '3',
				name: "50-64"
			}, {
				id: '4',
				name: "65+"
			}];

			this._selectedDepartTime = {
				range: {
					startTime: {
						title: 'Time',
						selectedTime: this.selectedTime || new Date()
					}
				}
			};

			this._departDateDetails = {
				disablePreviousDates: true,
				title: "Date",
				selectedDate: this.selectedDate || new Date(),
			};

			// if http call is running to fetch origin address details
			this.originAddressDetailsFetchPromise = null;
			// if http call is running to fetch destination address details
			this.destinationAddressDetailsFetchPromise = null;
		}

		bindAndValidateDirectionDetails({ details, shouldValidateOrigin }) {
			this.hideShowLoader({
				$event: false
			});
			this.directionDetails = clone(details);
			this._validateDirectionDetails(details, shouldValidateOrigin)
		}

		showHideAdvanceOptions() {
			this.isAdvanceOptionsEnabled = !this.isAdvanceOptionsEnabled;
		}

		onServiceTypeChange(id) {
			this.selectedServiceType = id;
		}

		applyFilters() {
			this.onApply({
				$event: this.selectedServiceType
			});
		}

		onChangeAge(id) {
			this.advanceOptionsDetails.age = id;
		}

		onChangeSpecialRequirements(requirements) {
			this.advanceOptionsDetails.requirements = requirements;
		}

		onChangeVeteranOptions({ id }) {
			this.advanceOptionsDetails.isVeteran = id;
		}

		onChangeMedicaidOptions({ id }) {
			this.advanceOptionsDetails.isMedicaid = id;
		}
		getOriginDestinationRequestPromise(promise) {
			if(promise.originAddressDetailsFetchPromise) {
				// http call running for fetching origin address details from server
				this.originAddressDetailsFetchPromise = promise.originAddressDetailsFetchPromise;
			}
			if(promise.destinationAddressDetailsFetchPromise) {
				// http call running for fetching destination address details from server
				this.destinationAddressDetailsFetchPromise = promise.destinationAddressDetailsFetchPromise;
			}
		}
		addMedicaidTransportationDetailsInGoogleAnalytics() {
			const eventName = 'medicaidTransportationLink';
			
            const attributes = {
                eventCategory: `${eventName}Category`,
                eventAction: `${eventName}Action`,
                eventLabel: 'Medicaid transport link',
				eventNonInteraction: false
            };
            
            this.googleAnalytics.event(eventName, attributes);
		}
		submit() {
			this.hideShowLoader({
				$event: true
			});

			this.$timeout(_ => {
				let promises = [];
				// check if any origin or destination fetching http request is running
				if(this.originAddressDetailsFetchPromise) {
					promises = promises.concat(this.originAddressDetailsFetchPromise);
				}
				if(this.destinationAddressDetailsFetchPromise) {
					promises = promises.concat(this.destinationAddressDetailsFetchPromise);
				}
				(promises.length > 0 ? Promise.all(promises) : Promise.resolve())
					.then(_ => this._validateDirectionDetails(this.directionDetails))
					.then(_ => this._checkIsOriginAndDestinationSame(this.directionDetails))
					.then(_ => this._changeTripPlanningResult(this.directionDetails))
					.then(_ => this._closeTripPlanningForm())
					.catch(err => this._getDirectionError(err));
			}, 1000);
		}

		_closeTripPlanningForm() {
			this.hideShowLoader({ $event: false });
			this.onCloseTripPlanningForm();
		}

		_changeTripPlanningResult() {
			let originServiceAreas = [];
			let destinationServiceAreas = [];

			let { origin, destination } = this.directionDetails;

			const originServiceAreaNames = this._getFormattedPlaceNameByPlaceDetails(origin);
			const destinationServiceAreaNames = this._getFormattedPlaceNameByPlaceDetails(destination);

			return this._getServiceAreaLatlngDetailsByPlaceName(originServiceAreaNames)
				.then(details => this.tripPlannerService.getLatlngDetailsObject(details))
				.then(placeDetails => originServiceAreas = JSON.stringify([...placeDetails]))
				.then(_ => this._getServiceAreaLatlngDetailsByPlaceName(destinationServiceAreaNames))
				.then(details => this.tripPlannerService.getLatlngDetailsObject(details))
				.then(placeDetails => destinationServiceAreas = JSON.stringify([...placeDetails]))
				.then(_ => this._redirectToTripPlannerResultPage(origin, destination, originServiceAreas, destinationServiceAreas, this.advanceOptionsDetails))
				.catch(err => {
					throw err;
				});
		}

		_redirectToTripPlannerResultPage(origin, destination, originServiceAreas, destinationServiceAreas, { requirements = "", age = "", isVeteran = null, isMedicaid = null }) {
			this.$state.go('tripPlannerResults', {
				originName: origin.name,
				destinationName: destination.name,
				originServiceAreas,
				destinationServiceAreas,
				originLat: origin.latlng.lat,
				originLng: origin.latlng.lng,
				destinationLat: destination.latlng.lat,
				destinationLng: destination.latlng.lng,
				requirements,
				age,
				isVeteran,
				isMedicaid
			});
		}

		_getDirectionError(error = '') {
			this.originCoverageError = !this.isValidOrigin ? error : '';
			this.destinationCoverageError = !this.isValidDestination ? error : '';
			this.destinationCoverageError = this.isOriginAnDestinationSame ? error : this.destinationCoverageError;
		}

		_checkIsOriginAndDestinationSame({ origin, destination }) {
			return new Promise((resolve, reject) => {
				this.isOriginAnDestinationSame = (origin.name.trim() === destination.name.trim()) ? true : false;
				this.isOriginAnDestinationSame ? reject('Origin and Destination should not be same') : resolve();
			});
		}

		_departAtApply() {
			this.onApply({
				$event: {
					selectedDate: this._departDateDetails.selectedDate,
					selectedTime: this._selectedDepartTime.range.startTime.selectedTime,
				}
			});
		}

		_validateDirectionDetails({ origin, destination }, shouldValidateOrigin = true) {
			return new Promise((resolve, reject) => {
				//validate detination details
				if (destination && destination.latlng) {
					this.destinationCoverageError = ''
					this._validateDestinationDetails(destination);
				} else {
					this.isValidDestination = false;
					reject('');
				}
				// validate origin details
				if (origin && origin.latlng && shouldValidateOrigin) {
					this._validateOriginDetails(origin)
						.then(_ => resolve())
						.catch(err => reject(err));
				}

				(this.isValidOrigin && this.isValidDestination) ? resolve() : reject();
			});
		}

		_validateOriginDetails(origin) {
			this.originCoverageError = '';
			return this._validateServiceArea(origin)
				.then(_ => {
					this.originCoverageError = '';
					this.isValidOrigin = true;
				})
				.catch(err => {
					this.originCoverageError = 'Selected area is not serviced for trip planning';
					this.isValidOrigin = false;
					throw err;
				});
		}

		_validateDestinationDetails(destination) {
			this.isValidDestination = this.destinationCoverageError ? false : true;
		}

		_checkIfAtleastCountyAvailable({ countyName }) {
			return (countyName) ? '' : 'Selected area is not serviced for trip planning';
		}

		_validateServiceArea(placeDetails) {
			const serviceAreaNames = this._getFormattedPlaceNameByPlaceDetails(placeDetails);

			return this._getServiceAreaLatlngDetailsByPlaceName(serviceAreaNames)
				.then(details => this.tripPlannerService.getLatlngDetailsObject(details))
				.then(originServiceAreas => this._validateCoverageArea(originServiceAreas))
				.then(_ => '')
				.catch(err => {
					throw err;
				});
		}

		_getFormattedPlaceNameByPlaceDetails({ countyName = '', townName = '', villageName = '', townshipName = '', stateCode = '', countryCode = '' }) {
			const availableServiceAreasList = this._formCombinationOfServiceAreaToRetrieveLatLng([countyName, townName, villageName, townshipName]);
			return availableServiceAreasList.map(list => this._getFullPlaceNameWithStateAndCountryCode(list, stateCode, countryCode))
		}

		_getFullPlaceNameWithStateAndCountryCode(availableServiceAreasList, stateCode, countryCode) {
			const serviceAreas = [...availableServiceAreasList, stateCode, countryCode];
			return serviceAreas.join(',');
		}

		_getPlaceLatlng(placeName, placeShortName, { geometry: { location: { lat, lng } } }) {
			return {
				placeName,
				placeShortName: this._removeCountyWordServiceArea(placeShortName),
				latlng: {
					lat: lat(),
					lng: lng()
				}
			}
		}

		_formCombinationOfServiceAreaToRetrieveLatLng(serviceAreasName) {
			const areas = serviceAreasName.reduce((area, value) => {
				if (value !== '') {
					area = [value, ...area];
				}
				return area;
			}, []);

			return areas.map((value, index) => areas.slice(index));
		}

		_getServiceAreaNameByPlaceDetails({ countyName = '', townName = '', villageName = '', townshipName = '', stateCode = '', countryCode = '' }) {
			const [availableServiceAreasList] = this._formCombinationOfServiceAreaToRetrieveLatLng([countyName, townName, villageName, townshipName]);
			const [serviceArea] = availableServiceAreasList;

			return this._removeCountyWordServiceArea(serviceArea);
		}

		_getServiceAreaLatlngDetailsByPlaceName(serviceAreaName) {
			const serviceAreaLatlngDetails = serviceAreaName.map(placeName => this.googleLocationService.getLocationDetailsByPlaceName(placeName));
			return Promise.all(serviceAreaLatlngDetails);
		}

		_validateCoverageArea(details) {
			return this.tripPlannerService.validateCoverageArea(details);
		}

		_removeCountyWordServiceArea(county) {
			return county ? county.replace('County', '').trim() : county;
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/components/trip-planner/trip-planner-form/trip-planner-form.component.js